import React from 'react';
import { useFloatingParticles } from '../../hooks/useAnimations';

interface FloatingParticlesProps {
  count?: number;
  className?: string;
}

// Memoized to prevent re-renders from parent component state changes
export const FloatingParticles = React.memo<FloatingParticlesProps>(({
  count = 12,
  className = ''
}) => {
  const { particlesRef, containerClasses, particles } = useFloatingParticles(count);

  return (
    <div
      ref={particlesRef}
      className={`${containerClasses} ${className}`}
    >
      {particles.map((particle) => (
        <div
          key={particle.id}
          className={particle.classes}
          style={particle.style}
        />
      ))}
    </div>
  );
});

FloatingParticles.displayName = 'FloatingParticles';
